import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { UnAuthorizedComponent } from './pages/errors/un-authorized/un-authorized.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './modules/shared.module';
import {MenuItems} from './modules/menu-items/menu-items';
import {BreadcrumbsComponent} from './layout/admin/breadcrumbs/breadcrumbs.component';

import { AuthService } from './services/auth/auth.service';
import { AuthGuard } from './services/auth/auth.guard';
import { RoleGuard } from './services/auth/role.guard';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ConsignmentsService } from './services/shipments/consignments/consignment.service';
import { AnalyticsService } from './services/analytics/analytics.service';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NotFoundComponent,
    UnAuthorizedComponent,
    BreadcrumbsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule 
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    AuthService,
    AuthGuard,
    RoleGuard,
    MenuItems,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts